import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { validateUsername } from '@/lib/utils';
import { UsernameRegistrationComponent } from './UsernameRegistration.component';

export const UsernameRegistration = () => {
  const { needsUsername, registerUsername, loading: authLoading } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validation = validateUsername(username);
    if (!validation.valid) {
      setError(validation.error || 'Invalid username');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await registerUsername(username);
      toast({
        title: 'Welcome to tuval.space!',
        description: `Your username "${username}" has been registered.`,
      });
      navigate(`/board/${username}`);
    } catch (error) {
      console.error('Username registration error:', error);
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to register username';
      setError(errorMessage);
      toast({
        title: 'Registration failed',
        description: errorMessage,
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleUsernameChange = (value: string) => {
    setUsername(value);
    setError(null);
  };

  return (
    <UsernameRegistrationComponent
      needsUsername={needsUsername}
      username={username}
      loading={loading}
      error={error}
      authLoading={authLoading}
      onUsernameChange={handleUsernameChange}
      onSubmit={handleSubmit}
    />
  );
};

